<template>
  <div
    class="w-full h-screen overflow-hidden"
    :class="[decoration ? 'grid grid-rows-auto-1-auto' : 'bg-gray-300']"
  >
    <wd-header v-if="decoration" />
    <div class="w-full overflow-hidden" :class="[decoration ? 'grid grid-cols-auto-1' : '']">
      <wd-sidebar v-if="decoration" />
      <main
        class="bg-gray-100 overflow-hidden overflow-y-auto"
        :class="{'p-4 grid grid-rows-auto-1': decoration}"
      >
        <div class="bg-primary-200 text-primary-900 px-4 py-2 -mx-4 -mt-4 mb-2" v-if="routeName">
          <wd-button transparent @input="goBack" v-if="routeMeta.back">
            <icon class="-mt-1" name="Back" size="1.3em" />
          </wd-button>
          <h2 class="ml-3 inline text-sm">{{ $t(routeName) }}</h2>
        </div>
        <router-view />
      </main>
    </div>
    <wd-footer v-if="decoration" />
    <dialogs />
    <popups />
  </div>
</template>

<script>
const Popups = require("@/modules/popups/components/Popups.vue").default;
const WdHeader = require("@/modules/header/components/WdHeader.vue").default;
const WdFooter = require("@/modules/footer/components/WdFooter.vue").default;
const WdSidebar = require("@/modules/sidebar/components/WdSidebar.vue").default;
const Dialogs = require("@/modules/dialogs/components/Dialogs.vue").default;

export default {
  name: "app",
  data() {
    return {
      loading: true
    };
  },
  components: {
    Popups,
    WdHeader,
    WdFooter,
    WdSidebar,
    Dialogs
  },
  methods: {
    goBack() {
      if (typeof this.routeMeta.back === "string") {
        this.goTo(this.routeMeta.back);
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    logged() {
      return this.$store.getters["auth/logged"];
    },
    routeMeta() {
      return this.$route.meta;
    },
    routeName() {
      return this.routeMeta.hideTitle !== true ? this.$route.name : false;
    },
    decoration() {
      return this.routeMeta.decoration !== undefined
        ? this.routeMeta.decoration
        : true;
    }
  },
  created() {},
  async mounted() {
    switch (process.env.NODE_ENV) {
      case "development":
      case "dev":
      case "local":
        console.groupCollapsed("[DEBUG]: WD CLIENT DEBUG INFORMATION");
        console.table(process.env);
        console.info(this.$store.getters);
        console.groupEnd();
        break;
    }

    this.loaded();
  }
};
</script>